<template>
  <div class="exams-data-table">
    <table class="exams-data-table-table">
      <colgroup>
        <col class="exams-data-table-cell-batch">

        <col class="exams-data-table-cell-exam">

        <col class="exams-data-table-cell-status">

        <col class="exams-data-table-cell-due-date">

        <col class="exams-data-table-cell-arrow">
      </colgroup>

      <thead class="exams-data-table-header">
        <tr class="exams-data-table-header-row">
          <th
            class="exams-data-table-header-cell"
          >
            Lote/Amostra(s)
          </th>

          <th
            class="exams-data-table-header-cell"
          >
            Exame
          </th>

          <th
            class="exams-data-table-header-cell"
          >
            <div class="exams-data-table-header-cell-status-content">
              <div class="exams-data-table-header-cell-status-status">
                Status
              </div>

              <div class="exams-data-table-header-cell-status-date">
                Data atualização
              </div>
            </div>
          </th>

          <th class="exams-data-table-header-cell">
            Data prevista
          </th>

          <th class="exams-data-table-header-cell" />
        </tr>
      </thead>

      <tbody class="exams-data-table-body">
        <template v-for="exam in os.exams">
          <tr
            class="exams-data-table-body-row"
            :class="{
              'exams-data-table-open-row': openRows.includes(exam.id)
            }"
            @click="handleToggleRowDetails(exam)"
          >
            <td
              class="exams-data-table-body-cell exams-data-table-body-cell-batch"
            >
              <div
                v-if="exam.lotId"
                class="exams-data-table-body-cell-batch-id"
              >
                {{ exam.lotId }}
              </div>

              <div
                v-if="exam.codeSample"
                class="exams-data-table-body-cell-batch-code"
              >
                {{ exam.codeSample }}
              </div>
            </td>

            <td
              class="exams-data-table-body-cell exams-data-table-body-cell-exam"
            >
              {{ exam.codeExamBrand }}
            </td>

            <td
              class="exams-data-table-body-cell exams-data-table-body-cell-status"
            >
              <exam-status-bar
                :events="exam.events"
                :due-date="exam.dueDate"
                :exam="exam"
              />
            </td>

            <td
              class="exams-data-table-body-cell exams-data-table-body-cell-due-date"
            >
              {{ exam.dueDate | date }}
            </td>

            <td
              class="exams-data-table-body-cell exams-data-table-body-cell-arrow"
            >
              <svg-loader
                src="/static/images/icon-caret.svg"
                class="exams-data-table-caret"
              />
            </td>
          </tr>

          <tr
            v-if="openRows.includes(exam.id)"
            class="exams-data-table-body-details-row"
          >
            <td :colspan="2" />

            <td class="exams-data-table-body-details-cell">
              <exam-events-list :events="exam.events" />
            </td>

            <td :colspan="2" />
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'

import ExamStatusBar from './ExamStatusBar'
import ExamEventsList from './ExamEventsList'

export default {
  name: 'ExamsDataTable',
  components: {
    ExamStatusBar,
    ExamEventsList,
  },
  filters: {
    date: (value) => moment(value).format('DD/MM/YYYY [às] HH:mm')
  },
  props: {
    os: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      openRows: []
    }
  },
  methods: {
    handleToggleRowDetails(order) {
      if (this.openRows.includes(order.id)) {
        this.openRows = this.openRows.filter(id => id !== order.id)
      } else {
        this.openRows = [...this.openRows, order.id]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.exams-data-table {
  width: 100%;
  font-family: 'Exo 2';

  &-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }

  &-header {
    // &-row {}

    &-cell {
      font-weight: 600;
      font-size: 0.75rem;
      text-transform: uppercase;
      color: #7A7A7A;
      padding: 1.5rem 1rem;
      text-align: left;

      &-status {
        &-content {
          display: flex;
          gap: 1rem;
          justify-content: space-between;
        }

        // &-status {}

        // &-date {}
      }
    }
  }

  &-body {
    &-row {
      cursor: pointer;

      &:hover {
        background-color: #EFEFEF;
      }
    }

    &-cell {
      padding: 1.5rem 1rem;
      vertical-align: top;

      &-batch {
        &-id {
          display: inline-block;
          background-color: #999999;
          padding: 0.25rem 0.5rem;
          border-radius: 0.25rem;
          font-weight: 600;
          font-size: 0.875rem;
          text-transform: uppercase;
          color: #FFFFFF;
          margin-bottom: 0.25rem;
        }

        &-code {
          font-weight: 400;
          font-size: 0.875rem;
          color: #595959;
        }
      }

      &-exam {
        font-size: 0.875rem;
        font-weight: 400;
        color: #595959;
      }

      // &-status {}

      &-due-date {
        font-weight: 400;
        font-size: 0.875rem;
        color: #595959;
      }

      // &-arrow {}
    }

    &-details {
      // &-row {}

      &-cell {
        background-color: #F3F3F3;
        padding-top: 0.5rem;
        padding-left: 1rem;
        padding-right: 1rem;
        padding-bottom: 2rem;
      }
    }
  }

  &-cell {
    // &-batch {}

    // &-exam {}

    &-status {
      width: 480px;
    }

    &-due-date {
      width: 190px;
    }

    &-arrow {
      width: 60px;
    }
  }

  &-caret {
    width: 0.5rem;
    min-width: auto;
    transform: rotate(180deg);
    transition: transform 0.2s ease;
  }

  &-open-row &-caret {
    transform: rotate(0deg);
  }
}
</style>
